import { compose, setDisplayName } from 'recompose';
import { withI18n } from 'lingui-react';

import ModalComponent from './ModalComponent';
import withDeleteMutation from './withDeleteMutation';

export default compose(
  setDisplayName('RotationDeleteModal'),
  withI18n(),
  withDeleteMutation,
)(ModalComponent);



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/RotationSchedulePanel/RotationDeleteModal/index.js